import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { defaultBagConditionsOptions, getConditionsFilterConfig } from '../filters/condition';

export const tortugabackpacksShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig({ options: defaultBagConditionsOptions }),
    getBrandDirectFilterConfig(),
  ],
};
